import { NotificationLayout, NotificationsContainer } from './Notification.styles'
import { Box, Divider, Typography } from '@mui/material'
import SingleNotification from './SingleNotification';
import NotificationHeader from './NotificationHeader';
import { useAppDispatch } from '../../../../hooks/StoreHooks';
import { useAllNotificationList, useUnreadNotificationAmount, useUnreadNotificationList } from '../../../../store/selectors/notificationSelector';
import { useEffect, useState } from 'react';
import { fetchNotificationListThunk, fetchUnreadNotificationAmountThunk } from '../../../../store/thunk/notificationThunk';
import NotificationPagination from './NotificationPagination';

const NotificationContent = () => {
  const dispatch = useAppDispatch();
  const allNotificationList = useAllNotificationList();
  const unreadNotificationList = useUnreadNotificationList();
  const unreadCount = useUnreadNotificationAmount();

  const [headerMenuSelected, setHeaderMenuSelected] = useState(0)
  const [paginationSelected, setPaginationSelected] = useState(1)
  const notificationList = headerMenuSelected === 0 ? unreadNotificationList : allNotificationList;
  const totalNotificationCount = notificationList?.totalCount || 0;
  const offsetValue = 10 * (paginationSelected - 1)
  const pageCounter = Math.max(1, Math.ceil(totalNotificationCount / 10));

  useEffect(() => {
    dispatch(fetchUnreadNotificationAmountThunk());
    dispatch(fetchNotificationListThunk({ offset: 0, limit: 10, status: "All" }));
  }, [dispatch]);

  useEffect(() => {
    if (paginationSelected > pageCounter) {
      setPaginationSelected(pageCounter);
    }
    const status = headerMenuSelected === 0 ? "Unread" : "All";
    dispatch(fetchNotificationListThunk({ offset: offsetValue, limit: 10, status }));
  }, [offsetValue, headerMenuSelected, paginationSelected, dispatch, pageCounter]);

  const handleHeaderMenu = (selected: number) => {
    setHeaderMenuSelected(selected);
  }

  const handlePagination = (selected: number) => {
    setPaginationSelected(selected);
  }

  const notificationsToRender = notificationList?.items.map(note => (
    <SingleNotification
      key={note.id}
      notificationData={note}
      currentOffset={offsetValue}
      currentStatus={headerMenuSelected === 0 ? "Unread" : "All"}
    />
  )) ?? [];

  return (
    <NotificationLayout>
      <Box>
        <Typography color="text.secondary" variant="body2">
          <NotificationHeader
            headerMenuSelected={headerMenuSelected}
            setHeaderMenu={handleHeaderMenu}
            totalCount={allNotificationList.totalCount}
            unreadCount={unreadCount}
          />
        </Typography>
      </Box>
      <Divider />
      <NotificationsContainer>
        <Typography color="text.secondary" variant="body2">
          {notificationsToRender}
        </Typography>
      </NotificationsContainer>
      <Box>
        <NotificationPagination
          paginationSelected={paginationSelected}
          setPagination={handlePagination}
          totalCount={totalNotificationCount}
        />
      </Box>
    </NotificationLayout>
  )
}

export default NotificationContent